import { render, staticRenderFns } from "./LessonDownloadButton.vue?vue&type=template&id=5e795610&scoped=true"
import script from "./LessonDownloadButton.vue?vue&type=script&lang=js"
export * from "./LessonDownloadButton.vue?vue&type=script&lang=js"
import style0 from "./LessonDownloadButton.vue?vue&type=style&index=0&id=5e795610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e795610",
  null
  
)

export default component.exports